import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { PageSlotModule } from '@spartacus/storefront';

import { ScrollSpyService } from '@seb/web-design-system/core';

import { AbstractPageComponent } from '../../templates/abstract-page/abstract-page.component';
import { CustomJsonLdDirective } from '../../directives';

@Component({
  selector: 'wc-new-generation-page',
  templateUrl: './new-generation-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PageSlotModule,
    CustomJsonLdDirective
  ]
})
export class NewGenerationPageComponent extends AbstractPageComponent implements AfterViewInit, OnInit, OnDestroy {
  constructor(
    private readonly scrollSpyService: ScrollSpyService,
    @Inject(PLATFORM_ID) private readonly platformId: any
  ) {
    super();

    this.snippetsOptions = { images: true, videos: true };
    this.eagerLoadingSlot = 'DynamicBody';
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.scrollSpyService.spy({ thresholdBottom: 300, thresholdTop: 60 });
    }
  }

  ngOnDestroy(): void {
    this.scrollSpyService.stopSpying();
    super.ngOnDestroy();
  }
}
